import React, { useEffect, useState } from "react";
import styles from "../assets/css/dashboard.module.css";
import { Bar } from "react-chartjs-2";
import axios from "axios";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";


import {
  rupee,
  question,
  user2,
  // chart,
  rupees,
  shipping,
  distributors,
  inspections,
  orders,
  speciality,
} from "../assets/img/index";

// Register chart components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);


export const DashboardKpi = () => {
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalOrders, setTotalOrders] = useState(0);
  const [totalRequirementsReceived, setTotalRequirementsReceived] = useState(0);
  const [totalProducts, setTotalProducts] = useState(0);
  const [totalDistributorsManufacturers, setTotalDistributorsManufacturers] = useState(0);
  const [totalSpecialities, setTotalSpecialities] = useState(0);
  const [totalInspectionRequests, setTotalInspectionRequests] = useState(0);
  const [totalInspection, setTotalInspection] = useState(0);
  const [totalShippingRequests, setTotalShippingRequests] = useState(0);
  const [totalEarnings, setTotalEarnings] = useState(0);

  const [inspectionRequests, setInspectionRequests] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // Track current page
  const [postsPerPage] = useState(5); // Set number of posts per page

  const token = localStorage.getItem("token");

  useEffect(() => {
    // Fetch Total Users
    fetch("https://mmq.mediquip.in/api/v1/users/total_users/")
      .then((response) => response.json())
      .then((data) => setTotalUsers(data.total_users || 0))
      .catch((error) => console.error("Error fetching total users:", error));

    // Fetch Total Orders
    fetch("https://mmq.mediquip.in/api/v1/product/order/order_count/")
      .then((response) => response.json())
      .then((data) => setTotalOrders(data.total_orders || 0))
      .catch((error) => console.error("Error fetching total orders:", error));

    // Fetch Total Requirements Received
    fetch("https://mmq.mediquip.in/api/v1/product/total_requirements_received/")
      .then((response) => response.json())
      .then((data) => setTotalRequirementsReceived(data.total_requirements_received || 0))
      .catch((error) => console.error("Error fetching total requirements:", error));

    // Fetch Total Products
    fetch("https://mmq.mediquip.in/api/v1/product/product_count/")
      .then((response) => response.json())
      .then((data) => setTotalProducts(data.total_products || 0))
      .catch((error) => console.error("Error fetching total products:", error));

    // Fetch Distributors and Manufacturer Count
    fetch("https://mmq.mediquip.in/api/v1/product/get_dist_manu_count/")
      .then((response) => response.json())
      .then((data) => {
        const totalCount = (data.distributor_count || 0) + (data.manufacturer_count || 0);
        setTotalDistributorsManufacturers(totalCount);
      })
      .catch((error) => console.error("Error fetching distributors and manufacturers:", error));

    // Fetch Total Specialities
    fetch("https://mmq.mediquip.in/api/v1/product/speciality/get_speciality_count/")
      .then((response) => response.json())
      .then((data) => setTotalSpecialities(data.total_specialities || 0))
      .catch((error) => console.error("Error fetching total specialities:", error));

    // Fetch Total Inspection Requests
    fetch("https://mmq.mediquip.in/api/v1/product/total_inspection_requests/")
      .then((response) => response.json())
      .then((data) => setTotalInspectionRequests(data.total_inspection_requests || 0))
      .catch((error) => console.error("Error fetching total inspection requests:", error));

    // Fetch Inspection Request Data
    fetch("https://mmq.mediquip.in/api/v1/product/total_inspection/")
      .then((response) => response.json())
      .then((data) => setInspectionRequests(data.user_details || []))
      .catch((error) => console.error("Error fetching inspection requests:", error));

    // Fetch Total Shipping Requests
    fetch("https://mmq.mediquip.in/api/v1/product/total_shipping_requests/")
      .then((response) => response.json())
      .then((data) => setTotalShippingRequests(data.total_shipping_requests || 0))
      .catch((error) => console.error("Error fetching total shipping requests:", error));

    // Fetch Total Earnings
    fetch("https://mmq.mediquip.in/api/v1/product/order/total_earnings/")
      .then((response) => response.json())
      .then((data) => setTotalEarnings(data.total_earnings || 0))
      .catch((error) => console.error("Error fetching total earnings:", error));
  }, []);

  // Get current posts
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentInspectionRequests = inspectionRequests.slice(indexOfFirstPost, indexOfLastPost);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const kpiData = [
    { title: "Total Product", img: rupee, fact: totalProducts },
    { title: "Total Users", img: user2, fact: totalUsers },
    { title: "Distributors and Manufacturer", img: distributors, fact: totalDistributorsManufacturers },
    { title: "Total Requirement received", img: question, fact: totalRequirementsReceived },
    { title: "Total Earning", img: rupees, fact: totalEarnings },
    { title: "Inspection Request", img: inspections, fact: totalInspectionRequests },
    { title: "Shipping Request", img: shipping, fact: totalShippingRequests },
    { title: "Total Orders", img: orders, fact: totalOrders },
    { title: "Total Speciality", img: speciality, fact: totalSpecialities },
  ];

  return (
    <section className={styles.dashBoardAnalytics}>
      <div className={styles.dashboardKpi}>
        {kpiData.map((value, key) => (
          <KPICard data={value} key={key} />
        ))}
      </div>

      <div className={styles.AnalyticsData}>
        <AnalyticsChart />
        {/* <InspectionRequestData
          inspectionRequests={currentInspectionRequests}
          paginate={paginate}
          totalInspectionRequests={totalInspectionRequests}
        /> */}
        {/* <ShippingRequestData totalShippingRequests={totalShippingRequests} /> */}
      </div>
    </section>
  );
};

const KPICard = ({ data }) => {
  return (
    <div className={styles.dashboardKpiCard}>
      <div className={styles.dashboardKpiCont}>
        <div>
          <span>
            <img src={data.img} alt="..." />
          </span>
        </div>
        <div>
          <h4>{data.title}</h4>
          <h1>{data.fact}</h1>
        </div>
      </div>
    </div>
  );
};

const AnalyticsChart = () => {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get("https://mmq.mediquip.in/api/v1/users/user_analytics/")
      .then((response) => {
        const data = response.data;

        // Map userTypeId to actual names
        const userTypeNames = {
          "1": "Distributor",
          "2": "Manufacturer",
          "3": "Normal",
        };

        // Prepare the datasets based on user types
        const userTypes = {}; // Store user type data dynamically
        data.data.forEach((entry) => {
          Object.entries(entry.user_types).forEach(([userTypeId, count]) => {
            const userTypeName = userTypeNames[userTypeId] || `User Type ${userTypeId}`; // Map the userTypeId to its name

            if (!userTypes[userTypeId]) {
              userTypes[userTypeId] = {
                label: userTypeName, // Use the mapped user type name
                data: new Array(data.labels.length).fill(0), // Initialize data for all years
                backgroundColor: "rgba(1, 156, 137, 1)", // Choose colors dynamically
                borderColor: "rgba(54, 162, 235, 1)",
                borderWidth: 1,
              };
            }

            // Find the corresponding index for the year
            const yearIndex = data.labels.indexOf(entry.year);
            if (yearIndex !== -1) {
              userTypes[userTypeId].data[yearIndex] = count; // Populate data for the year
            }
          });
        });

        // Convert the userTypes object to an array of datasets
        const datasets = Object.values(userTypes);

        setChartData({
          labels: data.labels, // ["2024", "2023"]
          datasets: datasets, // Multiple datasets based on user types
        });

        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching user analytics data:", error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <p>Loading chart...</p>;
  }

  return (
    <div className="w-full max-w-3xl mx-auto p-4 bg-white shadow-lg rounded-lg">
      <h2 className="text-lg font-bold text-center mb-4">User Analytics by Year</h2>
      {chartData && <Bar data={chartData} />}
    </div>
  );
};

export default AnalyticsChart;
